import { motion } from 'motion/react';
import { useInView } from "react-intersection-observer";

import useWindowSize from "../utils/windowsize";



const MotionDiv = ({order, children}) => {

    const windowSize = useWindowSize();
    let threshold;
    
    if (windowSize >= 600) {
        threshold = 0.35 // threshold om desktop
    } else {
        threshold = 0.1 // threshold om mobile
    }

    const [ref, inView] = useInView({
        threshold: threshold,   // Hur mycket av elementet måste vara synligt
    });

    const duration = 1
    const delay = 0

    return (
        <>
            <motion.div
                ref={ref}
                initial={{ opacity: 0, y: 50 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: -50 }}
                transition={{ duration, delay }}
            >
                {children}
            </motion.div>
        </>
)}


export default MotionDiv;